import React from "react";

import NoAnnouncementFoundIcon from "@/Components/Icons/NoAnnouncementFoundIcon";

const NoAnnouncementFound = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16">
      <NoAnnouncementFoundIcon />
      <p className="text-center text-base font-semibold text-primary">
        No Announcements available
      </p>
    </div>
  );
};

export default NoAnnouncementFound;
